module.exports = __webpack_public_path__ + "./assets/screenshot_home_messaging_mobile.png";